<template>
	<div class="full-height">
		<Header ref="menus" @menuChange="changeMenu"></Header>

		<div class="flex-center">
			<div class="main-container" ref="main">
				<div class="nav-bar">
					<span>
						当前位置：
						<a href="/">首页</a>
						<span> > </span>
						<a href="/contact">联系我们</a>

					</span>
				</div>

				<div class="flex" style="min-height: 465px;justify-content: center;width: 100%;padding: 20px 0;">
					<div class="text-overflow-hidden detail-container flex" style="width: 100%;justify-content: center;">
						<div>
							<div class="map" v-html="contact">
								<!-- <p style="color: rgb(0, 0, 0);font-family: Verdana, Arial, 宋体;font-size: 12px;font-style: normal;font-variant-ligatures: normal;font-variant-caps: normal;font-weight: 400;letter-spacing: normal;orphans: 2;text-indent: 0px;white-space: normal;widows: 2;word-spacing: 0px;-webkit-text-stroke-width: 0px;background-color: rgb(255, 255, 255);text-align: left"><span
									 style="color:#000000"><span style="font-size: 19px;font-family: 宋体">地址：河北省邯郸市邯山区陵园路60号 晋冀鲁豫烈士陵园</span></span></p>
								<p style="color: rgb(0, 0, 0);font-family: Verdana, Arial, 宋体;font-size: 12px;font-style: normal;font-variant-ligatures: normal;font-variant-caps: normal;font-weight: 400;letter-spacing: normal;orphans: 2;text-indent: 0px;white-space: normal;widows: 2;word-spacing: 0px;-webkit-text-stroke-width: 0px;background-color: rgb(255, 255, 255);text-align: left"><span
									 style="color:#000000"><span style="font-size: 19px;font-family: 宋体">联系电话：0310-3022896</span></span></p>
								<p style="color: rgb(0, 0, 0);font-family: Verdana, Arial, 宋体;font-size: 12px;font-style: normal;font-variant-ligatures: normal;font-variant-caps: normal;font-weight: 400;letter-spacing: normal;orphans: 2;text-indent: 0px;white-space: normal;widows: 2;word-spacing: 0px;-webkit-text-stroke-width: 0px;background-color: rgb(255, 255, 255);text-align: left"><span
									 style="color:#000000"><span style="font-size: 19px;font-family: 宋体">传真:0310-3022896</span></span></p>
								<p style="color: rgb(0, 0, 0);font-family: Verdana, Arial, 宋体;font-size: 12px;font-style: normal;font-variant-ligatures: normal;font-variant-caps: normal;font-weight: 400;letter-spacing: normal;orphans: 2;text-indent: 0px;white-space: normal;widows: 2;word-spacing: 0px;-webkit-text-stroke-width: 0px;background-color: rgb(255, 255, 255);text-align: left"><span
									 style="color:#000000"><span style="font-size: 19px;font-family: 宋体">咨询电话:0310-3128452</span></span></p>
								<p style="color: rgb(0, 0, 0);font-family: Verdana, Arial, 宋体;font-size: 12px;font-style: normal;font-variant-ligatures: normal;font-variant-caps: normal;font-weight: 400;letter-spacing: normal;orphans: 2;text-indent: 0px;white-space: normal;widows: 2;word-spacing: 0px;-webkit-text-stroke-width: 0px;background-color: rgb(255, 255, 255);text-align: left"><span
									 style="color:#000000"><span style="font-size: 19px;font-family: 宋体">投拆电话:0310-3022896</span></span></p>
								<p style="color: rgb(0, 0, 0);font-family: Verdana, Arial, 宋体;font-size: 12px;font-style: normal;font-variant-ligatures: normal;font-variant-caps: normal;font-weight: 400;letter-spacing: normal;orphans: 2;text-indent: 0px;white-space: normal;widows: 2;word-spacing: 0px;-webkit-text-stroke-width: 0px;background-color: rgb(255, 255, 255);text-align: left"><span
									 style="color:#000000"><span style="font-size: 19px;font-family: 宋体">邮箱:jjlylsly@hebmail.gov.cn</span></span></p>
								<p style="color: rgb(0, 0, 0);font-family: Verdana, Arial, 宋体;font-size: 12px;font-style: normal;font-variant-ligatures: normal;font-variant-caps: normal;font-weight: 400;letter-spacing: normal;orphans: 2;text-indent: 0px;white-space: normal;widows: 2;word-spacing: 0px;-webkit-text-stroke-width: 0px;background-color: rgb(255, 255, 255);text-align: left"><span
									 style="color:#000000"><span style="font-size: 19px;font-family: 宋体">英文网址:www.jjlylsly.cn</span></span></p>
								<p style="color: rgb(0, 0, 0);font-family: Verdana, Arial, 宋体;font-size: 12px;font-style: normal;font-variant-ligatures: normal;font-variant-caps: normal;font-weight: 400;letter-spacing: normal;orphans: 2;text-indent: 0px;white-space: normal;widows: 2;word-spacing: 0px;-webkit-text-stroke-width: 0px;background-color: rgb(255, 255, 255);text-align: left"><span
									 style="color:#000000"><span style="font-size: 19px;font-family: 宋体"></span></span><span style="font-size: 19px;font-family: 宋体"><span
										 style="color:#000000">中文网址:晋冀鲁豫烈士陵园.公益.cn</span></span></p>
								<p><br></p> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Footer>
		</Footer>
	</div>
</template>

<script>
	import Header from '../../components/Header';
	import Footer from '../../components/Footer';
	import api from '../../http/contact'
	import {
		formatTimeToStr
	} from '../../utils/date.js'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				nowMenuId: null,
				menus: {
					children: null
				},
				data: {

				},
				allMenus: [],
				contact : ''
			}
		},
		methods: {

			changeMenu(allMenu) {
				var query = this.$route.query;
				this.allMenus = allMenu
				const _this = this;
				if (this.data.parentMenu == null) {
					setTimeout(() => {
						_this.changeMenu(_this.allMenus);
					}, 500);
					return;
				}
				this.menus = allMenu.find(item => {
					if (item.id == this.data.parentMenu.id) {
						return true;
					}
				});
			},
			getMenuLink(item) {
				if (item.isOut == 1) {
					return item.url;
				}
				return '/detail?id=' + item.id + '&pid=' + item.parentId;
			},
			getContact(){
				api.getContact().then(res =>{
					this.contact = res.result;
				})
			}
		},
		created() {
			var query = this.$route.query;
		},
		mounted() {
			this.$refs.main.scrollIntoView()
			this.getContact()
		}
	}
</script>

<style scoped>
	.main-container {
		width: 1200px;
	}

	.nav-bar {
		text-align: left;
		width: 100%;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin: 23px 0;
	}

	.detail-container {
		margin: 23px 0 30px 30px;
		padding-right: 50pxs;
		width: 100%;
	}

	.menu-container {
		margin-right: 30px;
		background: #F7F7F7;
		height: fit-content;
	}

	.menu-item-container {
		width: 166px;
		height: 55px;
		color: #666666;
	}

	.menu-item-icontainer-active {
		background: #A10000;
		color: #FFFFFF !important;
	}

	.calendar {
		width: 110px;
		height: 98px;
		background-image: url("/static/img/icon/calendar.png");
		background-size: cover;
		margin-right: 10px;
	}

	.title {
		height: 21px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 20px;
	}

	.simple-content {
		margin-top: 16px;
		height: 17px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 16px;
	}

	.info-container {
		height: 100px;
	}

	.calendar-date {
		font-size: 20px;
		font-weight: bold;
	}

	.calendar-year {
		font-size: 18px;
		margin-top: 5px;
	}

	.art-title {
		height: 21px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		line-height: 21px;
	}

	.art-time {
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
		line-height: 16px;
		margin-top: 28px;
	}

	.art-pv {
		margin-top: -16px;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
		line-height: 16px;
	}

	.art-content {
		margin-top: 25px;
		text-align: left;
	}

	.art-remark {
		margin-top: 25px;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
		line-height: 16px;
	}
</style>



// WEBPACK FOOTER //
// src/views/contact/index.vue